<template>
  <div class="NewsListItem">
    <img v-lazy="src">
    <div class="textArea --noMargin">
      <div class="newsTitle" :class="{new:isNew}" v-html="title"></div>
      <div class="date">{{ date }}</div>
    </div>
  </div>
</template>

<script>
import { ymd } from "../assets/js/util";

export default {
  name: "NewsListItem",
  props: {
    title: {
      type: String,
      require: true
    },
    startDate: {
      type: Number,
      require: true
    },
    endDate: {
      type: Number,
      require: true
    },
    imgFlg: {
      type: Boolean,
      default: false
    },
    imagePath: {
      type: String,
      default: ''
    },
    isNew: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    src() {
      return this.imgFlg ? process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + this.imagePath : ''
    },
    date() {
      return ymd(this.startDate).join('.')
    }
  }
}
</script>

<style lang="scss" scoped>
.NewsListItem {
  display: flex;
  margin: 15px 15px 0;
  padding: 20px;
  background-color: #FFFFFF;
  border: 1px solid #E1DADB;
  border-radius: 12px;
  img {
    display: flex;
    height: 60px;
    width: 60px;
    border-radius: 4px;
  }
  img[lazy=loaded] {
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-name: scrollIn;
  }
  .textArea {
    padding-left: 15px;
    .newsTitle {
      font-size: 12px;
      color: #373737;
      &.new {
        background-image: url(../assets/Png/top/image_news_new.png);
        padding-top: 20px;
        background-size: 30px auto;
      }
    }
    .date {
      margin-top: 10px;
      font-size: 10px;
      color: #7E7E7E;
    }
  }
  .--noMargin {
    margin: 0;
  }
}
@keyframes scrollIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.new {
  color: red;
  font-size: 12px;
  & > img {
    width: 30px;
    height: auto;
  }
}
.new.hidden {
  visibility: hidden;
}
</style>
